/**
 * Simple Logger Utility
 * Provides consistent logging across the application
 */

class Logger {
  constructor(level = "info") {
    this.level = level;
    this.levels = {
      error: 0,
      warn: 1,
      info: 2,
      debug: 3,
    };
  }

  shouldLog(level) {
    return this.levels[level] <= this.levels[this.level];
  }

  formatMessage(level, message, ...args) {
    const timestamp = new Date().toISOString();
    const levelStr = level.toUpperCase().padEnd(5);
    const prefix = `[${timestamp}] ${levelStr}`;

    if (args.length > 0) {
      return `${prefix} ${message}`;
    }
    return `${prefix} ${message}`;
  }

  error(message, ...args) {
    if (this.shouldLog("error")) {
      console.error(this.formatMessage("error", message), ...args);
    }
  }

  warn(message, ...args) {
    if (this.shouldLog("warn")) {
      console.warn(this.formatMessage("warn", message), ...args);
    }
  }

  info(message, ...args) {
    if (this.shouldLog("info")) {
      console.log(this.formatMessage("info", message), ...args);
    }
  }

  debug(message, ...args) {
    if (this.shouldLog("debug")) {
      console.log(this.formatMessage("debug", message), ...args);
    }
  }

  log(message, ...args) {
    this.info(message, ...args);
  }
}

// Create default logger instance
export const logger = new Logger(process.env.LOG_LEVEL || "info");

// Export Logger class for custom instances
export { Logger };

// Default export for convenience
export default logger;
